import {APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ExtraOptions, PreloadAllModules, RouterModule} from '@angular/router';
import {MarkdownModule} from 'ngx-markdown';
import {FuseModule} from '@fuse';
import {FuseConfigModule} from '@fuse/services/config';
import {FuseMockApiModule} from '@fuse/lib/mock-api';
import {CoreModule} from 'app/core/core.module';
import {appConfig} from 'app/core/config/app.config';
import {mockApiServices} from 'app/mock-api';
import {LayoutModule} from 'app/layout/layout.module';
import {AppComponent} from 'app/app.component';
import {appRoutes} from 'app/app.routing';
import localEs from '@angular/common/locales/es-MX';
import {registerLocaleData} from '@angular/common';
import {UserService} from '@core/user/user.service';

registerLocaleData(localEs, 'es-MX');

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

export function initializeApp(userService: UserService) {
    return () => userService.initializeUser();
}

// @ts-ignore
/**
 * Creator: Fernando Tapia
 * Company: TAXSAT
 * Date: 20/01/2021
 *
 * Copyright TAXSAT
 */
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({})
    ],
    providers: [
        UserService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [UserService],
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'es-MX'
        },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'MXN'
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
